import api from "../api";

const getOrders = async () => {
  try {
    const isoTimestamp = new Date().toISOString(); // Convert the provided dateTime to ISO format
    const cacheBuster = Date.now(); // Cache busting parameter

    const response = await api.get(
      `${process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT}/app/appointment/simulator?page=1&pageSize=9999&populate=storeSimulator&populate=storeSimulator.store&populate=order&filter[status]=pending&filter[endTime][$gt]=${isoTimestamp}&sort=startTime&order=DESC&_t=${cacheBuster}`,
      {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('There was a problem with the axios operation:', error);
    throw error;
  }
};

export default getOrders;
